import { ErrorHandler, Injectable } from '@angular/core';
import { datadogRum } from '@datadog/browser-rum';

@Injectable({
	providedIn: 'root',
})
export class ErrorHandlerService extends ErrorHandler {
	constructor() {
		super();
	}

	handleError(error: Error) {
		const normalizedError = error instanceof Error ? error : new Error(String(error));

		// After a deployment, lazy-loaded chunks from the previous build no longer exist.
		// Reload the page to fetch the updated index.html and chunk references.
		if (normalizedError.name === 'ChunkLoadError') {
			window.location.reload();
			return;
		}

		console.log(normalizedError, normalizedError.message);
		datadogRum.addError(normalizedError);
		super.handleError(error);
	}
}
